<template>
  <div
    id="app"
    :style="{
           background:
        currentRoute.path == '/applicationTool' ||
        currentRoute.name == 'applicationTool'
          ? '#F1F1F8'
          : '#F7F7F7',
    }"
  >
    <div v-if="currentRoute.name === 'myApplication'" class="innerContainer">
      <RemoteLoginDialog :dialogVisible="dialogVisible" @sure="sure" :time="currentTime" />
      <Header
        v-if="
        currentRoute &&
        currentRoute.path != '/' &&
        currentRoute.path != '/login' &&
        currentRoute.path != '/courseIntroduce' &&
        currentRoute.path != '/intelligentScorm' &&
        isRouterAlive == true && !isTencent
      "
        :courseList="courseList"
      />
      <router-view v-if="isRouterAlive" />
      <Footer
        v-if="fitlerrout(currentRoute.path) == '-1'&&currentRoute.path !== '/applicationTool' && currentRoute.path !== '/coachPlatform'"
        :isLoginPage="
        currentRoute.path == '/' || currentRoute.path == '/login' ? true : false
      "
      />
    </div>
    <template v-else>
      <RemoteLoginDialog :dialogVisible="dialogVisible" :dialog-info="dialogInfo" @sure="sure" :time="currentTime" />
      <Header
        v-if="
        currentRoute &&
        currentRoute.path != '/' &&
        currentRoute.path != '/login' &&
        currentRoute.path != '/courseIntroduce' &&
        currentRoute.path != '/intelligentScorm' &&
        isRouterAlive == true && !isTencent
      "
        :courseList="courseList"
      />
      <router-view v-if="isRouterAlive" />
      <Footer
        v-if="fitlerrout(currentRoute.path) == '-1' && currentRoute.path !== '/leadershipDNA' && currentRoute.path !== '/applicationTool'&&currentRoute.path !== '/applicationToolTips'&&currentRoute.path !== '/projectCourseList'&&currentRoute.path !== '/campList'&&currentRoute.path!=='/campCouse'&&currentRoute.path !== '/coachPlatform'"
        :isLoginPage="
        currentRoute.path == '/' || currentRoute.path == '/login' ? true : false
      "
      />
    </template>
  </div>
</template>

<script>
import RemoteLoginDialog from './components/common/remoteLoginDialog.vue'
import Header from '@/layout/components/Header.vue'
import Footer from '@/layout/components/Footer.vue'
import { userinfo ,logout, enterpriseContent} from '@/api/user'
import { getStore,setSession,getSession,removeSession,setStore, clone, checkAndSetModuleId, removeStore,versionExamine,getTipBoxOption } from '@/utils/index'
import { heartbeatApi } from '@/api/heartbeat'
import config from '../package.json'
import axios from 'axios'
import {getVersion} from "./api/version";

export default {
  name: 'App',

  provide() {
    return {
      reload: this.reload,
      enterpriseContentState: this.enterpriseContentState,
    }
  },

  components: {
    Header,
    Footer,
    RemoteLoginDialog,
  },
  computed: {
    courseList: function () {
      // console.log("computedcomputedcomputed000", this.$store.state.user.courseList)
      return this.$store.state.user.courseList
    },
  },
  data() {
    return {
      isTencent: false,
      isRouterAlive: true,
      currentTime: '',
      currentRoute: '',
      timerInterval: '', //用户是否异地登录-定时器
      dialogVisible: false, //是否异地登录
      heartbeatTimer: '', //心跳接口-定时器
      dialogInfo:{
        content: this.$t("remoteLogin"),
        buttonText:this.$t("sure")
      },
      autoLogoutTimer:null,//定时器
      enterpriseContentLoaded: false,
      enterpriseContentState: {
        pcLogoUrl: ''
      }
    }
  },
  watch: {
    async $route(val, old) {
      console.log("APP监听路由切换val====", val)
      this.userAutherRouter(val)
      let token = ''
      if(this.getQueryString('token')){
        token = this.getQueryString('token');
        setStore('transtalen-token',token);
        if (this.currentRoute.path !== '/companyList') {
          removeStore('userInfo');//这里清除掉userInfo，在下面重新获取
        }
      }

      //获取版本信息
      getVersion().then(data => {
        if(data && data.version){
          versionExamine(data.version);
        }
      })

      // console.log("old====", old)
      if (val) document.title = this.$t('yyxt')
      this.currentRoute = val;

      //非登录页面，如果没有登录-跳转到登录页面
      if (this.currentRoute.path != '/' && this.currentRoute.path != '/login') {
        if(this.$route.query.source_env === "LMS_SCORM"){
          //从LMS平台过来
          localStorage.setItem("source_env", "LMS_SCORM");
          return;
        }
        let user_info = JSON.parse(getStore('userInfo'))
        if (!user_info) {
          if (this.currentRoute.path === '/companyList' && !this.hasOfficialLoginToken(token)) {
            this.toLoginPage();
            return;
          }
          console.log('路由监听的时候没有从本地缓存获取userinfo,执行getUserInfoFromRemote获取并注入userinfo','---------------------------------------------');
          await this.getUserInfoFromRemote(token);
        }
        if (this.currentRoute.path === '/companyList') {
          this.resetEnterpriseContent();
        } else {
          this.getEnterpriseContent();
        }
      } else {
        console.log('进入了登录页，清除全局缓存');
        this.clearGlobalStorage();
        this.resetEnterpriseContent();
      }
      console.log('路由监听userinfo注入完毕','---------------------------------------------');
      if (
        this.currentRoute.path == '/home' ||
        this.currentRoute.path == '/projectCourseList' ||
        this.currentRoute.path == '/applicationTool'
      ) {
        removeSession('learningPathMetaId')
      }

      // 心跳mouduId
      setSession('moduleId',val.meta.heart_beat_moduleId ? val.meta.heart_beat_moduleId : null);
    },
  },
  mounted() {
    //进来先清除掉actualwork
    if(getSession("actualwork")){
      removeSession("actualwork")
    }
    //这段逻辑是魔法逻辑，用于处理2023-4月广州OPPO多人使用一台电脑学习造成的userid重叠，无法统计学习时长
    if(location.href.indexOf('key=AOP3UJL1EYF3DHYKSGETENMOG42') !== -1){
      console.log('key=AOP3UJL1EYF3DHYKSGETENMOG42')
      this.clearGlobalStorage('localStorage');
    }

    // console.log("process==", process.env)
    // 监听 resize 方法
    // window.addEventListener("resize", this.renderResize, false)
    // document.title=this.$t('yyxt');
    if (
      process.env.ENV_CONFIG == 'devOverseas' ||
      process.env.ENV_CONFIG == 'prodOverseas' ||
      process.env.ENV_CONFIG == 'thdev' ||
      process.env.ENV_CONFIG == 'thuat' ||
      process.env.ENV_CONFIG == 'thprod'
    ) {
      let icon = 'static/favicon.ico' //  海外图片地址
      this.changeFavicon(icon) // 动态修改网站图标
    } else {
      let icon = 'static/favicon.ico' // 大陆图片地址
      // let icon = 'static/favicon-2904.ico' // 大陆图片地址
      this.changeFavicon(icon) // 动态修改网站图标
    }

    window.addEventListener("popstate",function(e){
      location.reload();
    },false)

    //等保用户需要走的逻辑（这里还拿不到sesstion里的protection 判断不了是不是等保用户 暂时所有用户都走监听用户行为 ）
    this.goLogin();
    this.monitorUserBehavior();

    this.postParentWindowLoaded();//通知父窗口加载完毕
  },
  beforeDestroy() {
    // 移除监听
    // window.removeEventListener("resize", this.renderResize, false)
  },

  async created() {
    // Stephen add 2025-03-11 腾讯对接
    this.isTencent = checkAndSetModuleId(this.getQueryString('moduleId'));
    console.log(this.isTencent, '🍔🍔🍔🍔🍔🍔🍔🍔🍔');
    // ------------------------------------------------------
    let token = ''
    if(this.getQueryString('token')){
      token = this.getQueryString('token');
      setStore('transtalen-token',token);
      removeStore('userInfo');//这里清除掉userInfo，在下面重新获取
    }
    if(this.getQueryString('userIdEncoder')){
      setStore('transtalenuserid',this.getQueryString('userIdEncoder'));
    }
    if(this.getQueryString('source_env')){
      console.log('设置source_env');
      setStore('source_env', this.getQueryString('source_env'));
    }

    if(getStore("source_env") === "LMS_SCORM"){
      await userinfo({}).then((res)=>{
        console.log(res,"Res");
        const userName = this.formatUserName(res.name);
        setStore("userInfo",{
          "userName": userName,
          "phone":res.phone,
          "companyId":res.companyId,
          "userId":res.id,
          "id": res.id,
          "accountNumber": res.accountNumber,
          "status": res.status
        })
        this.$EventBus.$emit('userInfoUpdated');
        return;
      })
    }
    let user_info = JSON.parse(getStore('userInfo'))
    if (!user_info) {
      if (this.$route.path === '/companyList' && !this.hasOfficialLoginToken(token)) {
        this.toLoginPage();
      } else {
        console.log('created的时候没有从本地缓存获取userinfo,执行getUserInfoFromRemote获取并注入userinfo','---------------------------------------------');
        await this.getUserInfoFromRemote(token);
      }
    }
    if (this.$route.path !== '/' && this.$route.path !== '/login' && this.$route.path !== '/companyList') {
      this.getEnterpriseContent();
    }
    // console.log("created app.vue==")
    this.$EventBus.$on('remoteLogin', (data) => {
      this.postParentWindowLoginOut()
      let userInfo = JSON.parse(getStore('userInfo'))
      if (userInfo) {
        this.setDialogVisible()
      } else {
        this.toLoginPage()
      }

      this.$EventBus.$off('remoteLogin', {})
    })


    console.log('开始获取心跳间隔并执行心跳','----------------------------------------');
    this.getTimeInter()
    this.toHeartbeatTimer()
  },
  // beforeDestroy() {
  // if (this.timerInterval) {
  //   clearInterval(this.timerInterval); //关闭
  // }
  // if (this.heartbeatTimer) {
  //   clearInterval(this.heartbeatTimer); //关闭
  // }
  // },

  methods: {
    formatUserName(name) {
      return name ? String(name).trim() : '';
    },
    hasOfficialLoginToken(token) {
      const t = token || getStore('transtalen-token');
      return !!(t && t !== 'null' && t !== 'undefined');
    },
    resetEnterpriseContent() {
      this.enterpriseContentLoaded = false;
      this.enterpriseContentState.pcLogoUrl = '';
    },
    getEnterpriseContent() {
      if (this.enterpriseContentLoaded || !getStore('transtalen-token')) {
        return;
      }
      this.enterpriseContentLoaded = true;
      enterpriseContent().then((res) => {
        const pcLogoUrl = res && res.logo && res.logo.pcLogoUrl ? String(res.logo.pcLogoUrl).trim() : '';
        this.enterpriseContentState.pcLogoUrl = pcLogoUrl;
      }, () => {
        this.enterpriseContentState.pcLogoUrl = '';
      });
    },
    fitlerrout(data) {
      // console.log("fitlerrout==", data)
      return data ? data.search('course') : 1
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        // this.courseList = this.$store.state.user.courseList;
      })
    },
    changeFavicon(link) {
      let $favicon = document.querySelector('link[rel="icon"]')
      // If a <link rel="icon"> element already exists,
      // change its href to the given link.
      if ($favicon !== null) {
        $favicon.href = link
      } else {
        $favicon = document.createElement('link')
        $favicon.rel = 'icon'
        $favicon.href = link
        document.head.appendChild($favicon)
      }
    },
    renderResize() {
      // 判断横竖屏
      // let width = document.documentElement.clientWidth
      // let height = document.documentElement.clientHeight
      // console.log("width==", width)
      // if (isIpad()) {
      //   // 刷新页面更新视图
      //   this.isRouterAlive = false
      //   this.$nextTick(function(){
      //       this.isRouterAlive = true
      //   })
      // }
      // if(width > height) {
      //     alert('横屏')
      // }
      // 做页面适配
      // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
    },
    // 获取浏览器信息
    getClientInfo() {
      //客户端信息
      let clientInfo = {
        referrer: document.referrer, //来源
        timeOpened: new Date().getTime(), //客户端时间戳
        timezone: new Date().getTimezoneOffset(), //本地时间与 GMT 时间之间的时间差
        pageon: location.pathname,
        previousSites: history.length, //历史堆栈的数量
        browserName: navigator.appName, //浏览器名称
        browserEngine: navigator.product, //引擎
        browserVersion1a: navigator.appVersion, //浏览器版本
        browserVersion1b: navigator.userAgent, //用户代理
        browserLanguage: navigator.language, //语言
        browserOnline: navigator.onLine, //是否在线
        browserPlatform: navigator.platform, //平台
        javaEnabled: navigator.javaEnabled(),
        dataCookies: (document.cookie.match(/[^\s;]+/g) || []).map((item) =>
          encodeURI(item)
        ), //cookie
        sizeScreenW: screen.width, //显示器尺寸
        sizeScreenH: screen.height, //显示器尺寸
        sizeDocW: document.documentElement.clientWidth, //页面可视区的宽度
        sizeDocH: document.documentElement.clientHeight, //页面可视区的高度
        sizeInW: window.innerWidth, //窗口的宽度
        sizeInH: window.innerHeight, //窗口的高度
        sizeAvailW: screen.availWidth, //浏览器的屏幕的可用宽度
        sizeAvailH: screen.availHeight, //浏览器的屏幕的可用高度
        scrColorDepth: screen.colorDepth, //设备调色板比特深度
        scrPixelDepth: screen.pixelDepth, //屏幕色彩分辨率
        //地理位置信息
        latitude: '',
        longitude: '',
        accuracy: '',
        altitude: '',
        altitudeAccuracy: '',
        heading: '',
        speed: '',
        timestamp: Date.now(),
      }
      return clientInfo
    },

    //心跳接口
    requestHeartbeat() {
      //海外版
      if (
        process.env.ENV_CONFIG == 'devOverseas' ||
        process.env.ENV_CONFIG == 'prodOverseas' ||
        process.env.ENV_CONFIG == 'thdev' ||
        process.env.ENV_CONFIG == 'thuat' ||
        process.env.ENV_CONFIG == 'thprod'
      ) {
        return
      }

      //情景模拟页面
      if (this.currentRoute.path == '/course/scenarioSimulationNew') {
        return
      }

      let appId = '1739e28a7bc179'
      if (process.env.ENV_CONFIG == 'shdev' || process.env.ENV_CONFIG == 'shuat'|| process.env.ENV_CONFIG == 'shupre') {
        appId = '1739e28a7bc100'
      }
      let learningPathMetaId = getSession('learningPathMetaId')
        ? getSession('learningPathMetaId')
        : ''
      let userInfo = JSON.parse(getStore('userInfo'))
      let userId = userInfo && userInfo.userId ? userInfo.userId : ''
      if (!userId) {
        return
      }
      let clientInfo = this.getClientInfo()
      // console.log("userInfo===", userInfo)
      // console.log("clientInfo===", clientInfo)
      // console.log("this.$router===", this.$router)
      // console.log("this.currentRoute===", this.currentRoute)
      let router = this.$router.history.current.fullPath
      if (!router || router == '/') {
        router = '/login'
      }
      let params = {
        actionContext: '',
        actionId: '1000',
        appId: appId,
        appName: 'transtalent_pc',
        appVersion: 'v.' + config.version,
        learningPathMetaId: learningPathMetaId,
        result: '',
        userId: userId,
        objectIds: [router,getSession('moduleId') ? Number(getSession('moduleId')) : null],
        clientInfo: clientInfo,
      }
      // console.log("paramsparams==", params)

      heartbeatApi(params).then(
        (res) => {
          // console.log(" ----- heartbeat ----", res);
        },
        (err) => {}
      )
    },

    toHeartbeatTimer() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer) //关闭
      }
      let that = this
      this.heartbeatTimer = setInterval(() => {
        that.requestHeartbeat()
      }, 30 * 1000)
    },

    getTimeInter() {
      let that = this
      let timerInterval = setInterval(() => {
        if (
          that.currentRoute.path == '/' ||
          that.currentRoute.path == '/login' ||
          that.currentRoute.path == '/companyList'
        ) {
          return
        }
        let userInfo = JSON.parse(getStore('userInfo'))
        if (userInfo && userInfo.userId) {
          that.getInterval()
          clearInterval(timerInterval) //关闭
        }
      }, 5000)
    },

    // 获取间隔时间
    getInterval() {
      this.$api.intervalValue().then(
        (res) => {
          // console.log(" ----- intervalValue ----", res);
          this.toTimerInterval(res)
        },
        (err) => {
          this.toTimerInterval(30)
        }
      )
    },

    toTimerInterval(interval) {
      if (this.timerInterval) {
        clearInterval(this.timerInterval) //关闭
      }
      let that = this
      this.timerInterval = setInterval(() => {
        if (getStore('userInfo')) {
          let userInfo = JSON.parse(getStore('userInfo'))
          if (userInfo && userInfo.userId) {
            that.getUserinfo()
          }
        }
      }, interval * 1000)
    },

    /**
     * 如果没有userinfo先从userinfo接口去取userinfo的数据
     * 然后存入localstorage里
     */
    getUserInfoFromRemote(token){
      let that = this;
      console.log('token',token);
      let mainApi = process.env.MAIN
      console.log("mainApi==", mainApi)
      return axios.request({
        url:   mainApi + '/ddilearner/v1/user/userinfo',
        method: 'get',
        headers:{
          "Content-Type": 'application/json;charset=utf-8',
          "transtalen-token": token || getStore('transtalen-token')
        }
      }).then((response) => {
        let res = response.data;
          console.log(res,'localstorage里没有userinfo，调用userinfo获取并注入localstorage','----------------------------------------',res);
          if(res && res['id']){
            const userName = this.formatUserName(res['name']);
            let cachedCompanyList = null;
            try {
              const raw = getStore('loginCompanyList');
              if (raw && raw !== 'null') {
                const list = JSON.parse(raw);
                if (Array.isArray(list) && list.length) {
                  cachedCompanyList = list;
                }
              }
            } catch (e) {}
            let info = {
              "userName": userName,
              "userId": res['id'],
              "id": res['id'],
              "phone": res['phone'],
              "password": "",
              "verificationCode":"",
              "type":"",
              "companyId":res['companyId'],
              "companyList": cachedCompanyList,
              "status": res['status'],
              "accountNumber": res['accountNumber']
            };
            setStore('userInfo', info);
            setSession("companyId",info.companyId);
            that.$EventBus.$emit('userInfoUpdated');
          }else{
            that.toLoginPage()
          }
      }).catch(err=>{
        that.toLoginPage()
      });
      // userInfoApi.then((res)=>{
      //   console.log('localstorage里没有userinfo，调用userinfo获取并注入localstorage','----------------------------------------',res);
      //   if(res['id']){
      //     let info = {
      //       "userName": res['name'],
      //       "userId": res['id'],
      //       "phone": res['phone'],
      //       "password": "",
      //       "verificationCode":"",
      //       "type":"",
      //       "companyId":res['companyId'],
      //       "companyList":null,
      //       "status": res['status']
      //     };
      //     setStore('userInfo', info);
      //     setSession("companyId",info.companyId);
      //     setSession("name", res['name']);
      //   }else{
      //     that.toLoginPage()
      //   }
      // },(err)=>{
      //   that.toLoginPage()
      // })
    },

    // 判断异地登录
    getUserinfo() {
      if (this.dialogVisible) {
        return
      }
      userinfo({}).then(
        (res) => {
          setSession("companyId",res.companyId)
        },
        (err) => {
          if ((err.code = 106)) {
            // this.setDialogVisible()
          }
        }
      )
    },

    setDialogVisible() {
      if(this.$route.path === '/login' || this.$route.path === '/companyList'){
        return;
      }
      setSession('userInfo', null)
      if (this.dialogVisible) {
        return
      }
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      this.currentTime = hh + ':' + mf
      this.dialogVisible = true
      this.clearGlobalStorage();
    },

    sure() {
      setSession('userInfo', null)
      this.dialogVisible = false
      this.$router.replace({ path: '/login' })
      this.clearGlobalStorage();
    },
    toLoginPage() {
      setSession('userInfo', null)
      if(this.$route.path !== '/login'){
        this.$router.replace({ path: '/login' })
      }
    },

    getQueryString(parameterName) {
      const parameters = window.location.href.split(/[?#&]/);
      console.log('parameters',parameters)
      for (const param of parameters) {
        const [name, value] = param.split('=');
        if (name === parameterName) {
          return value;
        }
      }
      return null;
    },

    goLogin(){
      let that = this;
      clearTimeout(that.autoLogoutTimer);
      if (that.$route.path == '/login') {
        return;
      }
      // 设置一个定时器，30分钟后执行登出操作
      that.autoLogoutTimer = setTimeout(()=>{
        if(getSession("protection") == "true"){//等保用户
          // 跳转至登录界面
          that.logout();
          setTimeout(() => {
            that.$msgBoxTip.showMsgBox(getTipBoxOption(
              that.$t("timeoutExit"),
              "error",
            ));
          }, 200);
        }
      }, 30 * 60 * 1000)
    },
    // 节流throttle代码（时间戳+定时器）
    throttle(fn, wait) {
      let timer = null;
      let startTime = Date.now();
      return function () {
        let curTime = Date.now();
        let remaining = wait - (curTime - startTime);
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        if (remaining <= 0) {
          fn.apply(context, args);
          startTime = Date.now();
        } else {
          timer = setTimeout(fn, remaining);
        }
      }
    },

    logout(){
      logout({},JSON.parse(getStore('userInfo')).type).then((res) => {
       this.clearGlobalStorage();
      })
      this.$router.push({ path: '/login'});
    },

    //监听用户30分钟内没有发生任何的交互操作发生（包含页面滚动、输入、点击、选择、hover、拖动、划取等）即自动登出，跳转至登录界面，并展示提示语
    monitorUserBehavior(){
        document.body.onmouseup = this.throttle(this.goLogin, 1000);
        document.body.onmousemove = this.throttle(this.goLogin, 1000);
        document.body.onkeyup = this.throttle(this.goLogin, 1000);
        document.body.onclick = this.throttle(this.goLogin, 1000);
        document.body.ontouchend = this.throttle(this.goLogin, 1000);
        window.addEventListener('resize', this.throttle(this.goLogin, 1000));
        window.addEventListener('scroll', this.throttle(this.goLogin, 1000));
    },

    //告诉父窗口登录失效：第三方对接
    postParentWindowLoginOut() {
      console.log('postParentWindowLoginOut')
      window.parent.postMessage({
        action: 'sessionExpiredConfirmed',
        vendor: 'DDI',
        params: {}
      },'*');
    },

    //告诉父窗口加载完成：第三方对接
    postParentWindowLoaded() {
      console.log('postParentWindowLoaded')
      window.parent.postMessage({
        action: 'iframeLoaded',
        vendor: 'DDI',
        params: {}
      },'*');
    },

    //这里判断路由，用于设置全局Header里的当前tab高亮逻辑
    userAutherRouter(route){
      console.log('当前高亮路由',route)
      if(route.path === '/applicationTool' || route.path === '/applicationToolTips' || route.name === 'applicationTool') {
        setSession('getUserAutherRouter','toolsAuthority')
        return;
      }
      else if(route.path === '/coachPlatform'){
        setSession('getUserAutherRouter','coachAuthority')
        return;
      }
      setSession('getUserAutherRouter','learningCenterAuthority')
    }
  },
}
</script>

<style>
.el-loading-mask {
  background-color: rgb(255, 255, 255) !important;
}
.tip-class {
  font-size: 0.0875rem;
  color: #929292;
  max-width: 30% !important;
  border-color: #e9eaf1 !important;
  padding: 0 0.0625rem !important;
  background-color: #f2f2f2 !important; /*设置矩形框的背景颜色*/
  box-shadow: 0 0.025rem 0.025rem 0.0125rem rgba(140, 140, 141, 0.25) !important;
  border-radius: 0 !important;
}
.el-tooltip__popper .popper__arrow {
  display: none !important;
}
.innerContainer {
  position: absolute;
  left: 0;
  top: .4063rem;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  /* color: #2c3e50; */
  /* padding-top: 85px; */
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none;
}
 ::-webkit-scrollbar {
   display: none;
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
body{
  overflow-x: hidden;
}
</style>





// WEBPACK FOOTER //
// src/App.vue